export const convertYouTubeIdToImg = ( videoId, type='jpg' ) => {
    switch ( type ) {
        case 'webp':
            return `https://i.ytimg.com/vi_webp/${ videoId }/maxresdefault.webp`;
        case 'jpg':
            return `https://img.youtube.com/vi/${ videoId }/maxresdefault.jpg`;
        case 'med/jpg':
            return `https://img.youtube.com/vi/${ videoId }/mqdefault.jpg`;
        case 'med/webp':
            return `https://i.ytimg.com/vi_webp/${ videoId }/mqdefault.webp`;
        case 'small/jpg':
            return `https://img.youtube.com/vi/${ videoId }/sddefault.jpg`;
        case 'small/webp':
            return `https://i.ytimg.com/vi_webp/${ videoId }/sddefault.webp`;
        default:
            return `https://img.youtube.com/vi/${ videoId }/maxresdefault.jpg`;
    }
};

export const YOUTUBE_URI_REGEX = /(?:youtu\.be\/|YouTube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})/i;
export const YOUTUBE_IMG_REGEX = /^(?:https:\/\/)?(?:img\.youtube\.com|i\.ytimg\.com)\/vi\/([^\/]+)\//i;
export const YOUTUBE_CHANNEL_REGEX = /(?:(?:http|https):\/\/)?(?:www\.)?youtube\.com\/(channel|user)\/([a-zA-Z0-9\-_]{1,})/i;
export const FACEBOOK_URI_REGEX = /^https?:\/\/(?:www\.)?facebook\.com.*\/(?:video(?:s)?|watch|story)(?:\.php\?id=|\/)([^\/&]+)\/?/;

export const parseYouTubeUrl = ( value='' ) => {
    if( typeof value !== 'string' ) {
        return false;
    }
    var address = null;
    var id = value.match( YOUTUBE_URI_REGEX );
    if( id && id[1] ) {
        address = id[1];
    }
    return address;
};

export const parseFacebookUrl = ( value='' ) => {
    if( typeof value !== 'string' ) {
        return false;
    }
    var address = value;
    var id = address.match( FACEBOOK_URI_REGEX );
    if( id && id[1] ) {
        address = id[1];
    }
    return address;
};
